export default {"src":"/_next/static/media/radio-blank.7f91121a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};